import { render, staticRenderFns } from "./LiveAnswer.vue?vue&type=template&id=75347823&scoped=true&"
import script from "./LiveAnswer.vue?vue&type=script&lang=js&"
export * from "./LiveAnswer.vue?vue&type=script&lang=js&"
import style0 from "./LiveAnswer.vue?vue&type=style&index=0&id=75347823&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75347823",
  null
  
)

export default component.exports